import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAiBotHeadLooking: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"ai-bot-head-looking, agent, robot"} maskId="square-filled-radius-0-stroke-1-IconAiBotHeadLooking"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM10.625 13H11.875V9H10.625V13ZM15.125 9V13H16.375V9H15.125Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAiBotHeadLooking;
